import React from 'react';
import CanvasWrapper from '../components/canvas/CanvasWrapper';

const Whiteboard: React.FC = () => (
  <CanvasWrapper />
);

export default Whiteboard;
